/* eslint-disable complexity */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { makePriceLabelRound } from "../../../../au-c2b/utils/helpers/make-price-label";
import { BOOL_STATE, LIVING_SITUATION, RESIDENCY_STATUS } from "../../../../constants/checkout-constants";
import editIcon from "./images/edit.svg";
import { AU_DESKTOP_EVENTS } from "../../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../../tracking";
import Tick from "./images/tick.svg";
import Tooltip from "../../../shared/tooltip";
import FinanceDisclaimerTooltipBody from "../../../shared/finance-disclaimer-tooltip-body/component";
import InfoIcon from "./images/info-icon.svg";
import { NUMBER } from "../../../../au-c2b/constants/app-constants";

const PreApprovalReadDetails = ({
    maxLoanAmount = 0,
    bestInterestRate,
    comparisonRate,
    financeData,
    handleEditcallback = () => {},
    inHouseFinanceEligibilityFinance
}) => {
    const { user = {}, loan = {}, loanType = {}} = financeData || {};
    const { firstName = "", middleName = "", lastName = "", dateOfBirth, address = {}, previousAddress = {}, residency, livingSituation, relationshipStatus, dependants} = user || {};
    const { deposit, term, balloon } = loan || {};
    const { isPurposeBusiness, isAbnRegistered, isGstRegistered, businessYears, businessMonths, abnYears, abnMonths, gstYears, gstMonths, typeOfBusiness } = loanType || {};
    const isCommercialForm = inHouseFinanceEligibilityFinance && isPurposeBusiness === "YES";
    const handleEdit = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.PRE_APPROVAl_EDIT_MY_ACCOUNT);
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.EDIT_FLOW, {
            eventAction: "Flow_source",
            eventLabel: "My account page"
        });
        handleEditcallback(true);
    };
    const getDurationLabel = (duration, type = "year") => {
        if (duration > 1) {
            if (type === "month") {
                return "months";
            }
            return "years";
        }
        return type;
    };
    return (
        <div>
            <p styleName={"styles.description"}>You’ve been pre-approved <img src={Tick} /></p>
            <div styleName={"styles.topBoxContainer"}>
                <div styleName={"styles.topsSectionWrapper"}>
                    <div styleName={"styles.sectionWrap"}>
                        <p styleName={"styles.top"}>6 lenders</p>
                        <p styleName={"styles.bottom"}>to choose loan offers from</p>
                    </div>
                    {isPurposeBusiness === BOOL_STATE.NO &&   <div styleName={"styles.sectionWrap"}>
                        <p styleName={"styles.top"}>{makePriceLabelRound(maxLoanAmount)}*</p>
                        <p styleName={"styles.bottom"}>Max. loan amount</p>
                    </div>}

                    {(bestInterestRate && !isNaN(bestInterestRate)) && <div styleName={"styles.sectionWrap"}>
                        <p styleName={"styles.top"}>@{bestInterestRate.toFixed(NUMBER.TWO)}%</p>
                        <p styleName={"styles.bottom"}>Interest rates starting</p>
                    </div>}
                    {(comparisonRate && !isNaN(comparisonRate)) && <div styleName={"styles.sectionWrap"}>
                        <p styleName={"styles.top"}>{comparisonRate.toFixed(NUMBER.TWO)}%</p>
                        <p styleName={"styles.bottom"}>Comparison rate
                            <Tooltip heading={``} displayComponent={FinanceDisclaimerTooltipBody} showComponent={true} displayComponentProp={{ showInHouse: true }}>
                                <span><img src={InfoIcon} /></span>
                            </Tooltip>
                        </p>
                    </div>}
                </div>
                <p styleName={"styles.conclusionText"}>*May vary depending on car age and KMs</p>
            </div>
            <div styleName={"styles.headingWrapper"}>
                <h3 styleName={"styles.heading"}>Your financing details</h3>
                <p styleName={"styles.editWrapper"} onClick={handleEdit}>
                    <img src={editIcon} alt={"editIcon"} />
                    Edit details
                </p>
            </div>
            <div styleName={"styles.boxWrapper"}>
                <div styleName={"styles.boxHeadingWrap"}>
                    <p styleName={"styles.detail"}>LOAN DETAILS</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Deposit amount</p>
                    <p styleName={"styles.subjectAmount"}>{makePriceLabelRound(deposit)}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Loan tenure</p>
                    <p styleName={"styles.subjectAmount"}>{term} {getDurationLabel(term)}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Balloon</p>
                    <p styleName={"styles.subjectAmount"}>{balloon}%</p>
                </div>
            </div>
            <div styleName={"styles.boxWrapper"}>
                <div styleName={"styles.boxHeadingWrap"}>
                    <p styleName={"styles.detail"}>LOAN TYPE</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Bussiness</p>
                    <p styleName={"styles.subjectAmount"}>{isPurposeBusiness}</p>
                </div>
                {isCommercialForm && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Type of business</p>
                    <p styleName={"styles.subjectAmount"}>{typeOfBusiness}</p>
                </div>}
                {isCommercialForm && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Bussiness Duration</p>
                    <p styleName={"styles.subjectAmount"}>{businessYears} {getDurationLabel(businessYears)} {businessMonths} {getDurationLabel(businessMonths, "month")}</p>
                </div>}
                {!isCommercialForm && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>ABN registered</p>
                    <p styleName={"styles.subjectAmount"}>{isAbnRegistered || "NO"}</p>
                </div>}
                {isCommercialForm && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>ABN Duration</p>
                    <p styleName={"styles.subjectAmount"}>{abnYears} {getDurationLabel(abnYears)} {abnMonths} {getDurationLabel(abnMonths, "month")}</p>
                </div>}
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>GST registered</p>
                    <p styleName={"styles.subjectAmount"}>{isGstRegistered || "NO"}</p>
                </div>
                {isCommercialForm && isGstRegistered === "YES" && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>GST Duration</p>
                    <p styleName={"styles.subjectAmount"}>{gstYears} {getDurationLabel(gstYears)} {gstMonths} {getDurationLabel(gstMonths, "month")}</p>
                </div>}
                {!isCommercialForm && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Bussiness Years</p>
                    <p styleName={"styles.subjectAmount"}>{businessYears || 0} {getDurationLabel(businessYears || 0)}</p>
                </div>}
            </div>
            <div styleName={"styles.boxWrapper"}>
                <div styleName={"styles.boxHeadingWrap"}>
                    <p styleName={"styles.detail"}>PERSONAL DETAILS</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Name</p>
                    <p styleName={"styles.subjectAmount"}>{`${firstName} ${middleName} ${lastName}`}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>D.O.B.</p>
                    <p styleName={"styles.subjectAmount"}>{dateOfBirth}</p>
                </div>
                {!isCommercialForm && !!relationshipStatus && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Relationship Status</p>
                    <p styleName={"styles.subjectAmount"}>{relationshipStatus}</p>
                </div>}
                {!isCommercialForm && typeof dependants === "number" && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>No of dependents</p>
                    <p styleName={"styles.subjectAmount"}>{dependants}</p>
                </div>}
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Residency status</p>
                    <p styleName={"styles.subjectAmount"}>{RESIDENCY_STATUS.filter((data) => data.value === residency)[0] && RESIDENCY_STATUS.filter((data) => data.value === residency)[0].label}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Address</p>
                    <p styleName={"styles.subjectAmount"}>{address.full}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Address Tenure</p>
                    <p styleName={"styles.subjectAmount"}>{address.durationYears} {getDurationLabel(address.durationYears)} {address.durationMonths} {getDurationLabel(address.durationMonths, "month")}</p>
                </div>
                {previousAddress.full &&
                    <React.Fragment>
                        <div styleName={"styles.flexWrapper"}>
                            <p styleName={"styles.subject"}>Previous Address</p>
                            <p styleName={"styles.subjectAmount"}>{previousAddress.full}</p>
                        </div>
                        <div styleName={"styles.flexWrapper"}>
                            <p styleName={"styles.subject"}>Previous Address Tenure</p>
                            <p styleName={"styles.subjectAmount"}>{previousAddress.durationYears} {getDurationLabel(previousAddress.durationYears)} {previousAddress.durationMonths} {getDurationLabel(previousAddress.durationMonths, "month")}</p>
                        </div>
                    </React.Fragment>
                }
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Living Situation</p>
                    <p styleName={"styles.subjectAmount"}>{(LIVING_SITUATION.filter((data) => data.value === livingSituation)[0] || {}).label}</p>
                </div>
            </div>
        </div>
    );
};

PreApprovalReadDetails.propTypes = {
    financeData: PropTypes.object,
    inHouseFinanceEligibilityFinance: PropTypes.bool,
    handleEditcallback: PropTypes.func,
    maxLoanAmount: PropTypes.number,
    bestInterestRate: PropTypes.number,
    comparisonRate: PropTypes.number
};

export default PreApprovalReadDetails;
